import { createHandlerChainRunner, createHandlerChainRunnerOptionalParameter } from '@insite/client-framework/HandlerCreator';
import {
    getBannerCarousel, GetBannerCarouselApiParameter, GetBannerCarouselModel,
    getBannerPreviewCarousel
} from '@NA/Services/GetBannerCarousel';
import { CustomApiHandler } from '@NA/Store/CustomHandlerCreator/CustomHandlerCreator';

type HandlerType = CustomApiHandler<GetBannerCarouselApiParameter, GetBannerCarouselModel>;

export const DispatchHomePageCarousel: HandlerType = (props: any) => {
    props.dispatch({
        type: "HomePage/GetHomePageCarousel",
        result: props.parameter,
    });
};

export const LoadHomePageCarousel: HandlerType = async (props: any) => {
    let ifPreviewBanner: any;
    if (typeof window !== 'undefined') {
        ifPreviewBanner = window.location.href.includes('previewbanner');
    }
    props.apiResult = props?.parameter?.isPreview ? await getBannerPreviewCarousel(props.parameter) : await getBannerCarousel(props.parameter);

};

export const DispatchCompleteLoadHomePageCarousel: HandlerType = props => {
    props.dispatch({
        type: "Homepage/DispatchCompleteLoadHomePageCarousel",
        bannerCarousel: props.apiResult,
    });
};

export const chain = [DispatchHomePageCarousel, LoadHomePageCarousel, DispatchCompleteLoadHomePageCarousel];

const homePageCarousel = createHandlerChainRunner(
    chain,

    "homePageCarousel",
);
export default homePageCarousel;
